import React, { Component } from 'react';
import {RegWrapper} from './RegWrapper.js';
import axios from 'axios';
import Fade from './Fade.js';
import {Loader} from './Loader.js';


export class EmailConfirmation extends Component {

    state = {
        success: null,
        isSending: true,
        errorMessage: ''
    }
   
    
    constructor(props) {
        super(props)
        this.props = props 
        
        this.token = this.props.match.params.token
    }

    componentDidMount() {
        
        // Проверяем наличие токена
        if (!this.token) {
            this.setState({
                success: false,
                isSending: false,
                errorMessage: 'Токен подтверждения отсутствует'
            });
            return;
        }
        
        axios
        .post('https://api.clickanti.ru/api/users/verify-email/', {
            token: this.token
        })
        .then(res => {
            // Успешное подтверждение
            if (res.status === 200 && res.data.message) {
                this.setState({
                    success: true,
                    isSending: false 
                });
            } else {
                this.setState({
                    success: false,
                    isSending: false,
                    errorMessage: 'Неожиданный ответ сервера'
                });
            }
        })
        .catch(err => {
            console.log('Email verification error:', err);
            
            let errorMessage = 'Ошибка подтверждения email';
            
            // Обработка ошибок от бекенда
            if (err.response && err.response.data) {
                if (err.response.data.error) {
                    errorMessage = err.response.data.error;
                } else if (err.response.status === 400) {
                    errorMessage = 'Неверный или истекший токен подтверждения';
                } else if (err.response.status === 404) {
                    errorMessage = 'Пользователь не найден';
                }
            } else if (err.request) {
                errorMessage = 'Ошибка соединения с сервером';
            }
            
            this.setState({
                success: false,
                isSending: false,
                errorMessage: errorMessage
            });
        })
    }
    
    render() {
        
        return (
            <RegWrapper showErrorMsg={false} >
                <Loader loader={this.state.isSending} />
            
            {/* Пока загружается */}
            {this.state.isSending && this.state.success === null && (
                <div>
                    <h1>Подтверждаем ваш email...</h1>
                </div>
            )}
            
            {/* Успешное подтверждение */}
            {this.state.success === true && (
                <div>
                    <div>
                        <h1>Спасибо, ваш Email подтвержден!</h1>
                    </div>
            
                    <div>
                        <a href='/auth' className="btn1">Вход</a>
                    </div>
                </div>
            )}
            
            {/* Ошибка подтверждения */}
            {this.state.success === false && (
                <div>
                    <h1>Ошибка подтверждения</h1>
                    <p style={{marginTop: '20px', fontSize: '16px'}}>
                        {this.state.errorMessage}
                    </p>
                    <div style={{marginTop: '30px'}}>
                        <a href='/reg' className="btn1" style={{marginRight: '10px'}}>
                            Регистрация
                        </a>
                        <a href='/auth' className="btn1">
                            Вход
                        </a>
                    </div>
                </div>
            )}
            
            </RegWrapper>
        )        
    }

}